const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlists';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-item',
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
});

const logWishlistCount = () => {
  const wishlistCount = getWishlist().length;
  if (wishlistCount != 0){
    document.querySelector('.wishlist-count').classList.add('active')
    document.querySelector('.wishlist-count').textContent = wishlistCount
  } else {
    document.querySelector('.wishlist-count').classList.remove('active')
  }
};

document.addEventListener('shopify-wishlist:updated', (event) => {
  logWishlistCount();
  initGrid();
  updateButtonsState(); // Добавлен вызов функции для обновления состояния всех кнопок
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  logWishlistCount();
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  logWishlistCount();
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');
      const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
      return productCard.outerHTML;
    })
    .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: {
      wishlist: wishlist
    }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;

    if (!productHandle) {
      console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
      return;
    }

    const updateButtonState = () => {
      const isWishlistItem = wishlistContains(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS, isWishlistItem);
    };

    updateButtonState();

    button.addEventListener('click', async () => {
      await updateWishlist(productHandle); // Используем updateWishlist вместо addToWishlist
      updateButtonsState();
    });
  });
};
const updateButtonsState = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (productHandle) {
      const isWishlistItem = wishlistContains(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS, isWishlistItem);
    }
  });
};
const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: {
      wishlist: getWishlist()
    }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);

  // Проверяем общее количество товаров
  const totalItems = array.length;
  // Устанавливаем класс "active" блоку в случае, если общее количество меньше нуля
  const wishlistBlock = document.querySelector('.wishlist-block');
  if (wishlistBlock) {
    if (totalItems <= 0) {
      wishlistBlock.classList.add('active');
    } else {
      wishlistBlock.classList.remove('active');
    }
  }

  if (totalItems) {
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  } else {
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  }

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: {
      wishlist: array,
    },
  });
  document.dispatchEvent(event);

  return wishlist;
};


const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};